import { render, staticRenderFns } from "./proteccion-personal.vue?vue&type=template&id=49b4d30e&scoped=true&"
import script from "./proteccion-personal.vue?vue&type=script&lang=js&"
export * from "./proteccion-personal.vue?vue&type=script&lang=js&"
import style0 from "./proteccion-personal.vue?vue&type=style&index=0&id=49b4d30e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b4d30e",
  null
  
)

export default component.exports